import styles from "./BrandImgInfoBanner.module.css";
import Helper from '../../utils/Helper';
import chevronLeft from "../../asset/icons/chevronLeft.png";
import { ReadMoreComp } from "../../components/ReadMoreComp/ReadMoreComp";
import { useNavigate } from "react-router-dom";
import { CoinNWallet } from "../../components";


export const BrandImgInfoBanner = ({brandData , isLoggedIn, type})=>{
    const navigate = useNavigate()
    const isMobile = Helper.isMobile()

    return(
        <div className={styles.brandInfoContainer}>
            <div className={styles.brandImageContainer}>
                <div className={styles.bannerNav}>
                    <button 
                      onClick={() => navigate('/marketplace')} 
                      className={styles.backButton}
                      aria-label="Go back to marketplace"
                      type="button"
                    >
                      <img className={styles.chevronLeft} alt="" src={chevronLeft} />
                    </button>
                    {type !== 'bundle' && isMobile && isLoggedIn && <CoinNWallet isLoggedIn={isLoggedIn} />}
                    {/* <img onClick={()=>{
                        navigate('/cart')
                    }} className={styles.cartIcon} alt="cartIcon" src={cartIcon} /> */}
                </div>
                <img 
                  src={brandData.banner_img} 
                  alt={`${brandData.name} brand banner`}
                  loading="eager"
                  fetchpriority="high"
                  decoding="async"
                  width="100%"
                  height="200"
                />
                {
                    type === 'bundle' ?
                    <div className={styles.bannerImg}>
                    {
                        brandData.image.map((i, index) => {
                            return <img 
                              style={{ zIndex: brandData.image.length - index  }} 
                              key={index} 
                              className={styles.brandImgCard} 
                              src={i} 
                              alt={`Brand logo ${index + 1}`}
                              loading="lazy"
                              decoding="async"
                              width="42"
                              height="42"
                            />
                        })
                    }
                </div>    
                    : ''
                }
                <div className={ styles.infoContainer}>
                    <div className={styles.LogoNameDetail}>
                        <div className={styles.LogoImageContainer}>
                            <img 
                              src={brandData.logo} 
                              alt={`${brandData.name} logo`}
                              loading="eager"
                              fetchpriority="high"
                              decoding="async"
                              width="56"
                              height="56"
                            />
                        </div>
                        <div className={styles.nameDetail}>
                            <h1 className={styles.brandName}>{brandData.name}</h1>
                            {brandData.subscriptionCount ? (
                              <p className={styles.subscription} aria-label={`${brandData.subscriptionCount} active subscriptions`}>
                                {brandData.subscriptionCount} Subscriptions
                              </p>
                            ) : null}
                        </div>
                    </div>
                    <div className={styles.brandinfoText} role="region" aria-label="Brand description">
                        <ReadMoreComp cut={120} text={brandData.desc}/>
                    </div>
                </div>
            </div>
        </div>
    )
}